import { ActionStatus } from '../../../common/constants/action-status';
import { StoreState } from '../../../store/store.interface';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { getCustomISBNSearchApiCall } from '../api/custom-isbn.api';

/*----- DECLARE THUNKS ------*/
export const getCustomISBNSearch = createAsyncThunk('orderCompletion/getCustomISBNSearch', async (isbn: any, thunkAPI) => {
  try {
    if (isbn) {
      return await getCustomISBNSearchApiCall(isbn);
    } else {
      return thunkAPI.rejectWithValue({
        message: 'Missing isbn.',
        isbn: isbn
      });
    }
  } catch (error) {
    return thunkAPI.rejectWithValue({
      error: error,
      isbn: isbn
    })
  }
}, {
  condition: ((_args: any, { getState }) => {
    const state = getState() as StoreState;
    return state.customISBNSearchState.status === ActionStatus.idle || !state.customISBNSearchState.data?.isbn.includes(_args);
  })
});
